<template>
	<div class="card border-0 card-with-shadow">
		<div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">

			<h5 v-show="isDetailsActive" class="card-title text-muted mb-0">{{ $t('details') }}</h5>
			<h5 v-show="!isDetailsActive" class="card-title text-muted mb-0">{{ $t('edit_details') }}</h5>

			<div>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoClose">
					<app-icon name="x-square" stroke-width="1"/>
				</a>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoSync">
					<app-icon name="check-square" stroke-width="1"/>
				</a>
				<a v-show="isDetailsActive  && !blockEdit" class="text-muted" href="#" @click.prevent="detailsInfoEdit">
					<app-icon name="edit" stroke-width="1"/>
				</a>
			</div>

		</div>
		<div class="card-body">

			<div v-show="isDetailsActive">
				<div class="form-group mb-3 pb-1">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('id') }}
						</label>
						<div class="col-7">
							{{ detailsData.fund_type.symbol }}{{ idNew }}
						</div>
					</div>
				</div>
				<div class="form-group mb-3 pb-1">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('title') }}
						</label>
						<div class="col-7">
							{{ detailsData.name }}
						</div>
					</div>
				</div>
				<div class="form-group mb-3 pb-1">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('lead_group') }}
						</label>
						<div class="col-7">
                                <span v-if="detailsData.fund_type"
                                      :class='`badge badge-sm badge-pill badge-${detailsData.fund_type.class}`'>
                                    {{ detailsData.fund_type.name }}
                                </span>
						</div>
					</div>
				</div>
				
				<div class="form-group mb-3 pb-1">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('years') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.year_on">
								{{ detailsData.year_on }} <span v-if="detailsData.year_off">- {{ detailsData.year_off }}</span>
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>
				<div class="form-group mb-3 pb-1">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('count') }}
						</label>
						<div class="col-7">
								{{ detailsData.count }} {{$t('qty')}}
						</div>
					</div>
				</div>
				<div class="form-group mb-3 pb-1">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('cond') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.cond">
								{{ detailsData.cond }}
								<span class="ml-2 small-size" v-if="(detailsData.cond == 1)">{{$t('cond_1')}}</span>
								<span class="ml-2 small-size" v-if="(detailsData.cond == 2)">{{$t('cond_2')}}</span>
								<span class="ml-2 small-size" v-if="(detailsData.cond == 3)">{{$t('cond_3')}}</span>
								<span class="ml-2 small-size" v-if="(detailsData.cond == 4)">{{$t('cond_4')}}</span>
								<span class="ml-2 small-size" v-if="(detailsData.cond == 5)">{{$t('cond_5')}}</span>
								<span class="ml-2 small-size" v-if="(detailsData.cond == 6)">{{$t('cond_6')}}</span>
								<span class="ml-2 small-size" v-if="(detailsData.cond == 7)">{{$t('cond_7')}}</span>
								<span class="ml-2 small-size" v-if="(detailsData.cond == 8)">{{$t('cond_8')}}</span>
								<span class="ml-2 small-size" v-if="(detailsData.cond == 9)">{{$t('cond_9')}}</span>
								<span class="ml-2 small-size" v-if="(detailsData.cond == 10)">{{$t('cond_10')}}</span>
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>
			
				<div class="form-group mb-3 pb-1">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('type_owners') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.type_owners">
								<span v-if="detailsData.type_owners == 1">{{ $t('type_owners_my') }}</span>
								<span v-if="detailsData.type_owners == 2">{{ $t('type_owners_rent') }}</span>
							</template>
							<template v-else>
								-
							</template>
							
						</div>
					</div>
				</div>

				<div class="form-group mb-3 pb-1">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('fund_created_at') }}
						</label>
						<div class="col-7">
							<template v-if="detailsData.created_at">
								{{formatDateToLocal(detailsData.created_at)}}
							</template>
							<template v-else>
								-
							</template>
						</div>
					</div>
				</div>
				<div class="form-group mb-3 ">
					<div class="form-row">
						<label class="mb-0 text-muted col-5 d-flex align-items-center">
							{{ $t('owner') }}
						</label>
						<div class="col-7">
							<div v-if="detailsData.owner" class="d-flex align-items-center">
								<span>{{ detailsData.owner.full_name }}</span>
							</div>
						</div>
					</div>
				</div>
				
				
							
			</div>

			<div v-show="!isDetailsActive">
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('title') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.name"
							           :error-message="$errorMessage(errors, 'name')"
							           type="text"/>
						</div>
					</div>
				</div>
				
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('lead_group') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.fund_type_id"
							           :error-message="$errorMessage(errors, 'fund_type_id')"
							           :list="contfundTypeList"
							           list-value-field='name'
							           type="select"/>
						</div>
					</div>
				</div>
				
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('years') }}</label>
						<div class="col-3">
							<app-input v-model="detailsData.year_on"
							           :error-message="$errorMessage(errors, 'year_on')"
										   :placeholder="$t('year_on')"
							           type="text"/>
						</div>
						<div class="col-1"></div>
						<div class="col-3">
							<app-input v-model="detailsData.year_off"
							           :error-message="$errorMessage(errors, 'year_off')"
										   :placeholder="$t('year_off')"
							           type="text"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('count') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.count"
							           :error-message="$errorMessage(errors, 'count')"
										   :placeholder="$t('count')"
							           type="number"/>
						</div>
					
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('cond') }}</label>
						<div class="col-7">
						<app-input
                  type="select"
                  list-value-field="name"
                  :list="CondList"
                  :placeholder="$t('choose_cond')"
                  v-model="detailsData.cond"
                  :error-message="$errorMessage(errors, 'cond')"
              />
						
						</div>
					</div>
				</div>

			
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('type_owners') }}</label>
						<div class="col-7">
						<app-input
                  type="select"
                  list-value-field="name"
                  :list="OwList"
                  :placeholder="$t('choose_type_owners')"
                  v-model="detailsData.type_owners"
                  :error-message="$errorMessage(errors, 'type_owners')"
              />
						
						</div>
					</div>
				</div>
				
				

				<div class="form-group mb-3">
					<div class="form-row">
					<label class="col-5 mb-0 d-flex align-items-center">{{ $t('rest') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.rest"
							           :error-message="$errorMessage(errors, 'rest')"
							           :list="peopleList"
							           list-value-field='name'
										    :placeholder="$t('choose_who')"
							           type="search-select"/>
							</div>
					</div>
				</div>
				
										 

				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('owner') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.owner_id"
							           :error-message="$errorMessage(errors, 'owner_id')"
							           :list="ownerList"
							           list-value-field='full_name'
							           type="select"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-0">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('fund_created_at') }}</label>
						<div class="col-7">
							<app-input
                      type="date"
                      :popover-position="'bottom-start'"
                      :placeholder="$t('fund_created_at')"
                      :required="true"
                      v-model="detailsData.created_at"
                    />
						</div>
					</div>
				</div>

			</div>

		</div>
	</div>
</template>

<script>

import {FormMixin} from "@core/mixins/form/FormMixin.js";
import {formatDateToLocal, urlGenerator} from "@app/Helpers/helpers";
import moment from "moment";

export default {
	name: "DetailsInformationFund",
	mixins: [FormMixin],
	props: {
		detailsData: {
			type: Object,
			required: true
		},
		detailsSyncUrl: {
			type: String,
			required: true
		},
		blockEdit: {
			type: Boolean,
			required: true
		},
	},
	data() {
		return {
			urlGenerator,
			formatDateToLocal,
			isDetailsActive: true,
			formData: {},
		
			
			countryList: [],
			CondList: [
	  		 	{ id: "1", name: "1",},
				{ id: "2", name: "2",},
				{ id: "3", name: "3",},
				{ id: "4", name: "4",},
				{ id: "5", name: "5",},
				{ id: "6", name: "6",},
				{ id: "7", name: "7",},
				{ id: "8", name: "8",},
				{ id: "9", name: "9",},
				{ id: "10", name: "10",},

	  		],
			OwList: [
	  		 	{ id: "1", name: "Собственник",},
				{ id: "2", name: "Аренда",},

	  		],
			errors: {}
		}
	},
	computed: {
		contfundTypeList() {
			return this.$store.getters.contfundType
		},
		
		idNew() {
			var number = this.detailsData.id;
			return ('00000' + number).slice(-5);
		},
		
		
		
		ownerList() {
			return this.$store.getters.getOwner
		},
		
		
	
		
		
		peopleList() {
			return this.$store.getters.getPerson
		},
		organizationList() {
			return this.$store.getters.getOrganization
		},
	},
	methods: {
		detailsInfoSync() {

			this.formData.name = this.detailsData.name;
			
			this.formData.year_on = this.detailsData.year_on;
			this.formData.year_off = this.detailsData.year_off;
			this.formData.cond = this.detailsData.cond;
			this.formData.count = this.detailsData.count;
			this.formData.country_made = this.detailsData.country_made;
			this.formData.country_buy = this.detailsData.country_buy;
			this.formData.inrest_id = this.detailsData.inrest_id;
			
			this.formData.type_owners = this.detailsData.type_owners;
			
			this.formData.date_buy = this.detailsData.date_buy ? moment(this.detailsData.date_buy).format(
        "YYYY-MM-DD"
      ) : null;

			
			this.formData.price_s = this.detailsData.price_s;
			this.formData.size = this.detailsData.size;
			this.formData.material = this.detailsData.material;
			this.formData.designer = this.detailsData.designer;
			this.formData.who = this.detailsData.who;
			this.formData.rest = this.detailsData.rest;
			this.formData.org = this.detailsData.org;
			this.formData.created_at = moment(this.detailsData.created_at).format("YYYY-MM-DD");
			
			
			this.formData.fund_type_id = this.detailsData.fund_type_id;
			this.formData.owner_id = this.detailsData.owner_id;
			this.submitFromFixin('patch', this.detailsSyncUrl, this.formData);
		},

		afterError(response) {
			this.errors = response.data.errors
		},

		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.isDetailsActive = true
			this.errors = {}
			this.$emit('update-request');
		},

		detailsInfoClose() {
			this.isDetailsActive = true;
			this.$emit('update-unblock');
		},
		detailsInfoEdit() {
			this.isDetailsActive = false;
			this.$emit('update-block');
			

		},
		getAllCountrys() {
			this.axiosGet(`crm/country`).then(({data}) => {
				this.countryList = data;
			});
		}
		
	},
	created() {
		this.$store.dispatch('contfundType');
		this.$store.dispatch('getOwner');
		
		
		
		this.$store.dispatch('getPerson');
		this.getAllCountrys();
	},
}
</script>

